import { apiAxios } from "@helpers/lib/axios";
import type { MixedItemDistAction } from "@hooks/types";
import { API_ENDPOINTS } from "@memorang/constants/urls";
import { sortTagsBySortOrder } from "@memorang/helpers/tag";
import type { MixedItemDist } from "@memorang/types";

interface MixedItemDistributionRequest {
	userPublicMetadataId: number;
	examId: string;
	action: MixedItemDistAction;
	collectionId?: number;
}
export async function getMixedItemDistribution(
	request: MixedItemDistributionRequest,
): Promise<MixedItemDist> {
	// if (isMocked) {
	// 	return mockedMixedItemDistribution;
	// }
	const params: Record<string, string | number> = {
		examId: request.examId,
		action: request.action || "",
	};

	if (request.collectionId) {
		params.collectionId = request.collectionId;
	}

	if (
		request.action === "GET_STUDYPACK_DISTRIBUTION" ||
		request.action === "COMMON_DISTRIBUTION"
	) {
		params.include = "recommendationContext";
	}

	const { data } = await apiAxios.get<{ data: MixedItemDist }>(
		API_ENDPOINTS.ITEM_DISTRIBUTION(request.userPublicMetadataId),
		{ params },
	);

	const mixedItemDist = data.data;

	return {
		...mixedItemDist,
		...(mixedItemDist.tags?.length > 0
			? { tags: sortTagsBySortOrder(mixedItemDist.tags) }
			: {}),
	};
}
